export default "__VITE_ASSET__7eb6877a__"